import React from 'react'
import {useInjection} from 'dna-react-ioc'
import {ITransactionsHistoryDataStore} from '@/pages/Overview'
import {observer} from 'mobx-react'
import {Table} from 'antd'
import {PaginationContainer} from '@/components'
import {useScreenType} from '@/hooks'
import {getColumns} from './constants'
import {LoadingState} from '@/types'

export const SettlementsTransactionsHistoryDataStoreSymbol = Symbol('SettlementsTransactionsHistoryDataStore')
export const SettlementsTransactionsHistoryPaginationStoreSymbol = Symbol('SettlementsTransactionsHistoryPaginationStore')

export const SettlementsTransactionsHistoryTable = observer(() => {
    const {isMobile} = useScreenType()
    const {data, loadingState} = useInjection<ITransactionsHistoryDataStore>(SettlementsTransactionsHistoryDataStoreSymbol)
    const columns  = getColumns()

    return (
        <>
            {isMobile && (
                <PaginationContainer
                    showOnlySizeChanger={true}
                    injectableIdentifier={SettlementsTransactionsHistoryPaginationStoreSymbol}
                />
            )}
            <Table
                loading={loadingState === LoadingState.LOADING}
                dataSource={data}
                columns={columns}
                pagination={false}
                scroll={{x: 1000}}
            />
            <PaginationContainer
                hideSizeChanger={isMobile}
                injectableIdentifier={SettlementsTransactionsHistoryPaginationStoreSymbol}
            />
        </>
    )
})
